module.exports = __webpack_public_path__ + "static/media/qualitas-star-icon.0ce5302e.svg";